import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    SetRingCentralIntegrationIsEnabled as SetRingCentralIntegrationIsEnabledMutation,
    SetRingCentralIntegrationIsEnabledVariables,
} from 'nutshell-graphql-types';

import SET_RINGCENTRAL_INTEGRATION_IS_ENABLED from '../mutations/set-ringcentral-integration-is-enabled.graphql';

export const useSetRingCentralIntegrationIsEnabled = (): {
    setRingCentralIntegrationIsEnabled: (arg1: boolean) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const [setRingCentralIntegrationIsEnabled, {loading, error}] = useMutation<
        SetRingCentralIntegrationIsEnabledMutation,
        SetRingCentralIntegrationIsEnabledVariables
    >(SET_RINGCENTRAL_INTEGRATION_IS_ENABLED);

    return {
        setRingCentralIntegrationIsEnabled: (isEnabled: boolean) =>
            setRingCentralIntegrationIsEnabled({variables: {isEnabled}}),
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
};
